export default __webpack_public_path__ + "static/media/1.a9e74439.png";